import {type IAsset} from '@netx/core-asset-next/schema';
import type {ISearchGalleryAsset} from '../schema';

export const convertAssetDataToGalleryAssetData = (
	assetData: IAsset,
): Omit<ISearchGalleryAsset, 'values'> => {
	return {
		...assetData,
		creationDate: assetData.creationdate,
		fileName: assetData.file,
		fileTypeLabel: assetData.filetypelabel,
		fileHeight: assetData.fileheight,
		fileSize: assetData.fileSize2,
		fileWidth: assetData.filewidth,
		id: assetData.assetId,
		importDate: assetData.importDate,
		modDate: assetData.moddate,
		pageCount: assetData.fileFormatFamily.includes('document')
			? assetData.constituentIds.length
			: 0,
		// preview: assetData.previewUrl,
		// thumb: assetData.thumbUrl,
	};
};

export default convertAssetDataToGalleryAssetData;
